<template>
    <div class="">
        <div class="page-top mb-1 mb-3 clearfix">
			<h1 class="float-left"> Team </h1>
            <router-link to="addTeam" class="btn btn-primary float-right"> Add Team </router-link>
		</div>
		<div class="peopple-managment-main">
			<div class="people-management-inner-content p-5">
				<div class="row align-items-start">
					<div class="col-md-6 mb-3" v-for="team in teams" v-bind:key="team.id">
						<div class="team-box p-4">
							<div class="team-head">
								<router-link :to="`/editTeam/${team.id}`"> {{team.name}} </router-link>
								<p> <span v-if="team.department!=null">Department: {{team.department.name}} |</span><span v-if="team.branch!=null"> Branch: {{team.branch.name}} </span></p>
							</div>
							<div class="members-section">
								<div class="members-content leads mb-2 clearfix">
									<div class="members-box text-center">
										<h3> Manager </h3>
										<ul class="members-list clearfix">
											<li class="members-list-item" v-if="team.manager.avatar==null">
												<img class="team-tooltip" data-toggle="tooltip" data-placement="top" :title="team.manager.name" src="/images/table-dummy-image.jpg" alt="" />
											</li>
											<li class="members-list-item" v-else>
												<img class="team-tooltip" data-toggle="tooltip" data-placement="top" :title="team.manager.name" :src="`/avatar/${team.manager.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
											</li>
										</ul>
									</div>
									<div class="members-box">
										<h3> Team Lead </h3>
										<ul class="members-list clearfix">
											<li class="members-list-item" v-for="team_member in (team.team)" v-bind:key="team_member.id" v-if="team_member.team_lead == 'YES'">
												<div v-if="team_member.member != null">
													<img class="team-tooltip" v-if="team_member.member.avatar==null" data-toggle="tooltip" data-placement="top" :title="team_member.member.name" src="/images/table-dummy-image.jpg" alt="" />
	                                                <img class="team-tooltip" v-else data-toggle="tooltip" data-placement="top" :title="team_member.member.name" :src="`/avatar/${team_member.member.avatar}`"  @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
	                                            </div>
											</li>
										</ul>
									</div>
								</div>
								<div class="members-content team-members clearfix">
									<div class="members-box">
										<h3> Members </h3>
										<ul class="members-list clearfix">
											<li class="members-list-item" v-for="team_member in (team.team)" v-bind:key="team_member.id" v-if="team_member.team_lead == 'NO'">
												<div v-if="team_member.member != null">
													<img class="team-tooltip" v-if="team_member.member.avatar==null" data-toggle="tooltip" data-placement="top" :title="team_member.member.name" src="/images/table-dummy-image.jpg" alt="" />
	                                                <img class="team-tooltip" v-else data-toggle="tooltip" data-placement="top" :title="team_member.member.name" :src="`/avatar/${team_member.member.avatar}`" @error="$event.target.src = '/images/table-dummy-image.jpg'" alt="" />
												</div>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                teams : null,
            };
            var completeTable = $(".team-tooltip").tooltip({
                title: '<b> Jawad Amjad </b> <br/> QA Department',
                html: true,
                placement: 'top',
                template: '<div class="tooltip custom-tooltip"><div class="arrow"></div><div class="tooltip-inner team-tooltip-inner"></div></div>'
            });
        },
        mounted() {
            this.$Progress.start();
            axios.get('/api/listTeams')
                .then(res => {
                    if(res.status == 200){
                        this.teams = res.data.teams;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load data'
                    });
                });
        },
        created() {
            //
        },
        methods: {
            //
        }
    }
</script>
